import * as PROJECT_CODE from '../../constants/projectCode';
import * as helloOauth from '../landing/HelloSignOauthTest/helloOauth'
import * as ORIGINAL_HREF from '../../constants/originalHref';
import * as ALL_DOCUMENTS from '../../constants/helloSignDocumentInfo';

export async function CancelAPSForm(firebase, clientInfo, authToken){
    console.log("Get Cancel APS Files " + clientInfo.salesAgentPointer);

    var jsonData = {clientInfo : clientInfo};
    jsonData['thisUserId'] = firebase.auth().currentUser.uid;;
    jsonData['projectCode'] = PROJECT_CODE.projectCode; 
    jsonData['authToken'] = authToken;
    jsonData['subjectName'] = ALL_DOCUMENTS.allDocumentTypeInfo.apsFirebaseInfo.subjectName;

    var getClientDocumentInfo = firebase
    .functions()
    .httpsCallable('HelloSignCancelSignatureRequest');

    //console.log(JSON.stringify(jsonData))
    //var clientFiles;
    var finalResult;

    await getClientDocumentInfo(jsonData).then((result) => {

        console.log('results: ' + JSON.stringify(result));
        finalResult = result;

    });

    return finalResult;

    //return clientFiles;
}

export async function CancelCondoForm(firebase, clientInfo, authToken){
    console.log("Get Cancel APS Files " + clientInfo.salesAgentPointer);

    var jsonData = {clientInfo : clientInfo};
    jsonData['thisUserId'] = firebase.auth().currentUser.uid;;
    jsonData['projectCode'] = PROJECT_CODE.projectCode; 
    jsonData['authToken'] = authToken;
    jsonData['subjectName'] = ALL_DOCUMENTS.allDocumentTypeInfo.condoDocFirebaseInfo.subjectName;

    var getClientDocumentInfo = firebase
    .functions()
    .httpsCallable('HelloSignCancelSignatureRequest');

    //console.log(JSON.stringify(jsonData))
    //var clientFiles;

    var finalResult;

    await getClientDocumentInfo(jsonData).then((result) => {

        console.log('results: ' + JSON.stringify(result));
        finalResult = result;

    })

    return finalResult;
    //return clientFiles;
}

export async function CancelExtraForm(firebase, clientInfo, authToken, subjectName){
    console.log("Get Cancel APS Files " + clientInfo.salesAgentPointer);

    var jsonData = {clientInfo : clientInfo};
    jsonData['thisUserId'] = firebase.auth().currentUser.uid;;
    jsonData['projectCode'] = PROJECT_CODE.projectCode; 
    jsonData['authToken'] = authToken;
    jsonData['subjectName'] = subjectName;

    var getClientDocumentInfo = firebase
    .functions()
    .httpsCallable('HelloSignCancelSignatureRequestExtras');

    //console.log(JSON.stringify(jsonData))
    //var clientFiles;
    var finalResult;

    await getClientDocumentInfo(jsonData).then((result) => {

        console.log('results: ' + JSON.stringify(result));
        finalResult = result;
        
    })

    return finalResult;
    //return clientFiles;
}